import { render, staticRenderFns } from "./EvaluationsTable.vue?vue&type=template&id=e8bfbbd2&scoped=true"
import script from "./EvaluationsTable.vue?vue&type=script&lang=js"
export * from "./EvaluationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bfbbd2",
  null
  
)

export default component.exports